import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./lib/auth";
import { AccountProvider } from "./lib/account";
import "./styles.css";
import "./editor-extras.css";
import "./ai-builder.css";
import "@twm/shared/site-design.css";
import "@twm/shared/header-menu.css";
import "@twm/shared/legal-notices.css";
import "@twm/shared/google-reviews.css";
import "./customization.css";
import "./offer.css";
import "./business-brand.css";
import "./billing.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <AuthProvider><AccountProvider><App /></AccountProvider></AuthProvider>
    </BrowserRouter>
  </StrictMode>
);
